import React from 'react';

import { SVGSpinner } from './SVG';

const buttonVariants = {
    primary: {
      base: 'bg-slate-950 text-white hover:bg-slate-800 dark:bg-white dark:hover:bg-slate-200 dark:text-slate-900 [&_svg]:fill-white dark:[&_svg]:fill-slate-900',
      disabled: 'bg-slate-950/80 text-white/50 dark:bg-white/80 dark:text-slate-900/50 cursor-not-allowed !scale-100 [&_svg]:fill-white/50 dark:[&_svg]:fill-slate-900/50'
    },
    secondary: {
      base: 'bg-slate-200 dark:bg-slate-800 text-slate-900 ring-1 ring-black/10 dark:ring-white/10 ring-inset dark:text-white hover:bg-slate-300 dark:hover:bg-slate-700 [&_svg]:fill-slate-900 dark:[&_svg]:fill-white',
      disabled: 'bg-slate-200/80 dark:bg-slate-800/80 text-slate-900/50 ring-1 ring-black/10 dark:ring-white/10 ring-inset dark:text-white/30 !scale-100 cursor-not-allowed [&_svg]:fill-slate-900/50 dark:[&_svg]:fill-white/50'
    },
    danger: {
      base: 'bg-red-500 text-white hover:bg-red-600',
      disabled: 'bg-red-500/50 text-white/80 cursor-not-allowed'
    },
    outline: {
      base: 'border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-white hover:bg-slate-100 dark:hover:bg-slate-800',
      disabled: 'border border-slate-300/50 dark:border-slate-700/50 text-slate-900/50 dark:text-white/50 cursor-not-allowed'
    }
  };
  
  export function Button({
    type = 'secondary', 
    label = 'Button', 
    onClick = null, 
    disabled = false, 
    loading = false,
    className = '',
    icon: Icon = null,
    iconPosition = 'left'
  }) {
    const variantStyles = disabled 
      ? buttonVariants[type].disabled 
      : buttonVariants[type].base;

    const handleOnClick = () => {
      if (onClick && !disabled && !loading) {
        onClick();
      }
    };
  
    return (
      <button 
        className={`
          flex relative gap-2 justify-center items-center h-12 px-6 w-auto z-[1]
          rounded-full
          active:scale-95
          transition-all duration-200 
          ${variantStyles} 
          ${className}
          ${loading ? '!scale-100' : ''}
        `}
        onClick={handleOnClick}
      >
            <div className={`flex gap-2 justify-center items-center z-[2] ${loading ? 'opacity-50' : 'opacity-100'}`}>
                {Icon && iconPosition === 'left' && <Icon classes={`h-4 shrink-0 relative`} />}
                <span className='block shrink-0'>{label}</span>
                {Icon && iconPosition === 'right' && <Icon classes={`h-4 shrink-0 relative`} />}
            </div>
            {loading && <div className='block absolute left-[50%] top-[50%] transform -translate-x-1/2 -translate-y-1/2 z-[1]'>
                <SVGSpinner classes={`h-6 shrink-0 relative animate-spin`} />   
            </div>}
        </button>
    );
  }

function SelectSwitchItem({label = 'Label', value = 'value', selected = false, setValue = null}){

    const handleSelect = (value) => {
        return () => {
            setValue(value);
        }
    }

    return (
        <button className={`flex-grow p-1 rounded-full flex justify-center items-center ${selected ? 'bg-slate-800 dark:bg-slate-100' : 'bg-slate-100 dark:bg-slate-800'}`} onClick={handleSelect(value)}>
            <span className={`${selected ? 'text-white dark:text-black' : 'text-auto dark:text-white'}`}>{label}</span>
        </button>
    );
}
export function SelectSwitch({options = [], setValue = null, currentValue = null}){
    return (
        <div className='flex gap-1 p-1 bg-slate-100 dark:bg-slate-800 rounded-full ring-1 ring-black/10 dark:ring-white/10 ring-inset'>
            {options.map((option, index) => {
                const isSelected = currentValue === option.value;
                return <SelectSwitchItem key={index} label={option.label} value={option.value} selected={isSelected} setValue={setValue} />;
            })}
        </div>
    );
}